// Dependency Reducer
export const GET_DEPENDENCY = 'GET_DEPENDENCY'
export const DEPENDENCY_ERROR = 'DEPENDENCY_ERROR'
